import React from 'react';
import { Globe2 } from 'lucide-react';

/**
 * Reassures Latin American buyers that the USD price is charged
 * in their own currency at checkout.
 */
export const LocalCurrencyNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`mx-auto w-full max-w-[320px] rounded-[14px] border border-brandGold/40 bg-bg-card px-3 py-2.5 ${className}`} data-id="element-377" data-mp="103h6o5psvpr3">
    <div className="flex items-start gap-2" data-id="element-378" data-mp="q6unrmh1b8rp">
      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brandGold/15 text-brandGold" data-id="element-379" data-mp="q7nx8v7docdj">
        <Globe2 size={13} aria-hidden="true" data-id="element-380" data-mp="leuolw8sgjw6" />
      </span>
      <div className="min-w-0 text-left" data-id="element-381" data-mp="hdr9xd2h8twj">
        <p className="font-sans font-bold uppercase tracking-[1.2px] text-[9.5px] md:text-[10px] text-brandGold" data-id="element-382" data-mp="hcg9nn88q4a6">
          Pagas en tu moneda local
        </p>
        <p className="font-sans text-[10.5px] md:text-[11.5px] leading-[1.4] text-txt-body mt-0.5" data-id="element-383" data-mp="7fbljhuu3yqq">
          El precio se convierte automáticamente al finalizar la compra.
        </p>
      </div>
    </div>
  </div>;